import React, { useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const { Title } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.forgotPassword(values.email);
      setSubmitted(true);
      message.success('If this email is registered, you will receive a password reset link.');
    } catch (error) {
      message.error(
        error.response?.data?.message ||
        'Failed to send reset link. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        {/* MaveshiBids Logo */}
        <div className="logo-section" style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img 
            src="/assets/images/logo.png" 
            alt="MaveshiBids" 
            style={{ 
              height: '60px', 
              cursor: 'pointer',
              transition: 'transform 0.2s ease'
            }}
            onClick={() => navigate('/')}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          />
      
        </div>

        <div className="login-header">
          <Title level={2}>Forgot Password</Title>
          <p>Enter your email address to receive a password reset link.</p>
        </div>
        {submitted ? (
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <p>Please check your email for a password reset link.</p>
            <Button type="primary" onClick={() => navigate('/login')}>Back to Login</Button>
          </div>
        ) : (
          <Form
            name="forgot-password"
            onFinish={onFinish}
            layout="vertical"
            className="login-form"
          >
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input
                prefix={<MailOutlined className="input-icon" />}
                placeholder="Enter your email"
                size="large"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
              >
                Send Reset Link
              </Button>
            </Form.Item>
            <div className="form-footer">
              <Button type="link" onClick={() => navigate('/login')} className="login-link">
                Back to Login
              </Button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword; 